import React, { useState, useEffect, useCallback } from 'react';
import { PillSearch } from '../../../components/ui';
import debounce from 'lodash/debounce';

interface Filters {
  searchQuery: string;
  location: { lat: number; lng: number; radius: number } | null;
  searchRadius: number;
  creatorTypes: ('influencer' | 'ugc')[];
}

const FilterBar = ({
  filters,
  onFiltersChange
}: {
  filters: Filters;
  onFiltersChange: (filters: Filters) => void;
}) => {
  const [searchQuery, setSearchQuery] = useState(filters.searchQuery || '');

  // Debounced update for search query
  const debouncedSearch = useCallback(
    debounce((query: string) => {
      onFiltersChange({
        ...filters,
        searchQuery: query
      });
    }, 300),
    [onFiltersChange]
  );

  useEffect(() => {
    setSearchQuery(filters.searchQuery || '');
  }, [filters]);

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    debouncedSearch(e.target.value);
  };

  return (
    <PillSearch
      placeholder="Search brands"
      aria-label="Search brands"
      type="search"
      value={searchQuery}
      onChange={handleSearchChange}
    />
  );
};

export default FilterBar; 